import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectError } from 'features/errors/errorsSelectors';
import { ConnectionErrorScreen } from './ConnectionErrorScreen';
import { GeneralErrorScreen } from './GeneralErrorScreen';
import { isMigrationInstance } from 'common/utils/migrationUtils';
import { getMapBridge } from 'features/map';

export const ErrorScreen = () => {
  const error = useSelector(selectError);

  console.error(error);

  const shouldBeClosed = isMigrationInstance();
  useEffect(() => {
    if (shouldBeClosed) {
      getMapBridge().closePage();
    }
  }, [shouldBeClosed]);
  if (shouldBeClosed) {
    return null;
  }

  return error?.message === 'Network request failed' || error?.message === 'Failed to fetch' ? (
    <ConnectionErrorScreen />
  ) : (
    <GeneralErrorScreen />
  );
};
